import { animated } from '@react-spring/web';
import cx from 'clsx';
import React, { type ReactElement } from 'react';
import { NavLink } from 'react-router-dom';

import useGetTextAppearanceAnimation from '@pages/Root/hooks/useGetTextAppearanceAnimation';

import { selectAppPersistSidebarResponse } from '@store/useAppStorePersist';

import style from './style.module.scss';

interface IProps {
  text: string;
  id?: string;
  to: string;
  tooltipId: string;
  icon: ReactElement;
  className?: string;
  children?: ReactElement;
  tooltipText?: string; //TODO: Temporary solution. Remove in a couple of months
}

const NavLinkItem: React.FC<IProps> = ({
  text,
  id,
  to,
  tooltipId,
  icon,
  className,
  children,
  tooltipText,
}) => {
  const { textAnimationStyles } = useGetTextAppearanceAnimation();

  const sidebarResponse = selectAppPersistSidebarResponse();

  return (
    <NavLink
      id={id}
      className={({ isActive }) =>
        cx(
          style.navItem,
          {
            [style.closedSidebarNavItem]: sidebarResponse,
            [style.navActive]: isActive,
          },
          className,
        )
      }
      to={to}
      data-tooltip-id={tooltipId}
      data-tooltip-content={tooltipText || text}
      end
    >
      <div>{icon}</div>
      <animated.div style={{ ...textAnimationStyles }}>
        <div className={style.textContainer}>{children || text}</div>
      </animated.div>
    </NavLink>
  );
};

export default NavLinkItem;
